import React from 'react';
import {  useSelector } from "react-redux";
import { t } from 'translates';

import Push from './Push';
import Product from './Product';
import Exhibition from './Exhibition';
import VizSensor from 'react-visibility-sensor';

function ProductListSection({ label, array, itemListName }) {
  const parrentFilter = useSelector((state) => state.products.current_filters.parent_category);
  let index = 0;
  return (
    <div className='products-list__wrapper'>
      {+parrentFilter === 0 ? (
        <h2 className='products-list__title'>{label}</h2>
      ) : (
        <h3 className='products-list__count'>{array.length} {t('results', DT_SESSIONSNEW)}</h3>
      )}
      {array.map((item) => {
        switch (item.type) {
          case 'product':
          case 'cursus':
            {
              index +=1
              const currentIndex = index;
              return  <VizSensor
                delayedCall={true}
                partialVisibility={true}
                key={item.id}
              >
                {({isVisible}) =>
                  <Product {...item} isVisible={isVisible} index={currentIndex} itemListName={itemListName} />
                }
              </VizSensor>
            }

          case 'manual_push':
            return <Push key={item.id} {...item}/>;
          case 'exhibition':
            return <Exhibition key={item.id} {...item}/>
        }
      })}
    </div>
  );
}

export default  ProductListSection;
